// extracted by mini-css-extract-plugin
export default {"button":"PrintResults_button__dmN3F","row":"PrintResults_row__v-jWh","dialog":"PrintResults_dialog__6ppYx"};